<template>
    <v-layout id="root">
        <slot></slot>
        <div id="overlay" v-show="loading || show" :style="{background: show_overlay ? '#00000033' : 'none'}">
            <v-progress-circular
                    indeterminate
                    :size="size"
                    :width="width"
                    color="primary"
                    :style="{
                        position: fixed ? 'fixed' : 'absolute',
                        top: 'calc(50% - '+(size/2)+'px)',
                        left: 'calc(50% - '+(size/2)+'px)'
                    }"
            ></v-progress-circular>
        </div>
    </v-layout>
</template>

<script>

export default {
  props: {
    'show': {
      default: false,
      type: Boolean
    },
    'fixed': {
      default: false,
      type: Boolean
    },
    'show_overlay': {
      default: true,
      type: Boolean
    },
    'size': {
      default: 80,
      type: Number
    },
    'width': {
      default: 7,
      type: Number
    }
  },
  data: () => ({
    loading: 0
  }),
  methods: {
    start () {
      this.loading++

      const el = this.$el.querySelector(':focus')
      if (el) {
        el.blur()
      }
    },
    done () {
      if (this.loading > 0) {
        this.loading--
      }
    }
  }
}

</script>

<style scoped>
    #root {
        position: relative;
    }

    #overlay {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 9999999;
        user-select: none;
    }
</style>
